import { render, staticRenderFns } from "./LoadingArea.vue?vue&type=template&id=028a0483&scoped=true&"
import script from "./LoadingArea.vue?vue&type=script&lang=js&"
export * from "./LoadingArea.vue?vue&type=script&lang=js&"
import style0 from "./LoadingArea.vue?vue&type=style&index=0&id=028a0483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a0483",
  null
  
)

export default component.exports